const freshConfig = {
  staging_eu: {
    host: 'https://wchat.freshchat.com',
    widget: 'https://wchat.freshchat.com/js/widget.js',
    token: '80f94737-3122-4eee-9241-ebe566732075',
    tags: ['merchantportal-{country}']
  },
  playground_eu: {
    host: 'https://wchat.eu.freshchat.com',
    widget: 'https://wchat.eu.freshchat.com/js/widget.js',
    token: 'f34afccd-cb8a-49b3-b8d9-c6d0055da762',
    tags: ['merchantportal-{country}']
  },
  production_eu: {
    host: 'https://wchat.eu.freshchat.com',
    widget: 'https://wchat.eu.freshchat.com/js/widget.js',
    token: 'f34afccd-cb8a-49b3-b8d9-c6d0055da762',
    tags: ['merchantportal-{country}']
  },
  production_us: {
    host: 'https://wchat.freshchat.com',
    widget: 'https://wchat.freshchat.com/js/widget.js',
    token: '86a7059a-314b-42ce-a58c-abca6e336097',
    tags: ['merchantportal-{country}']
  },
  playground_us: {
    host: 'https://wchat.freshchat.com',
    widget: 'https://wchat.freshchat.com/js/widget.js',
    token: '86a7059a-314b-42ce-a58c-abca6e336097',
    tags: ['merchantportal-{country}']
  },
  staging_oc: {
    host: 'https://wchat.au.freshchat.com',
    widget: 'https://wchat.au.freshchat.com/js/widget.js',
    token: '7bd76b27-663b-452d-9998-b0c16ee9fa37',
    tags: ['merchantportal-{country}']
  },
  production_oc: {
    host: 'https://wchat.au.freshchat.com',
    widget: 'https://wchat.au.freshchat.com/js/widget.js',
    token: '17105859-3291-45f1-9050-1b62c2f23246',
    tags: ['merchantportal-{country}']
  }
}

export default (env, region) => {
  const config = `${env}_${region}`.toLowerCase()
  return freshConfig[config] || freshConfig.staging_eu
}
